import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import _ from 'lodash';

let awsRum: AwsRum = null;

const getQueryParamsObject = (): {[key: string]: string} => {
    const searchParams = new URLSearchParams(location.search.slice(1));
    return searchParams
        ? _.fromPairs(Array.from(searchParams.entries()))
        : {};
};
export const recordCustomEvent = <T>(eventName: string, eventData: T) => {
    if (window.awsRumEnabled) {
        const searchParamsObject = getQueryParamsObject();

        awsRum.recordEvent(eventName, {
            data: {
                contentType: searchParamsObject.contentType,
                workspaceId: searchParamsObject.workspaceId,
                userInteraction: {
                    event: eventData,
                },
            },
        });
    }
};

export const initRum = (): void => {
    if (window.awsRumEnabled) {
        try {
            const config: AwsRumConfig = {
                sessionSampleRate: 1,
                guestRoleArn: window.awsRum.awsRumGuestRoleArn,
                identityPoolId: window.awsRum.awsRumIdentityPoolId,
                endpoint: window.awsRum.awsRumEndpoint,
                telemetries: ['performance', 'errors', 'http'],
                allowCookies: true,
                enableXRay: false,
                pagesToExclude: [/\/author\/\?/],
            };

            const APPLICATION_ID = window.awsRum.awsRumAppAdminAppId;
            const APPLICATION_VERSION = '1.0.0';
            const APPLICATION_REGION = 'eu-west-1';

            awsRum = new AwsRum(
                APPLICATION_ID,
                APPLICATION_VERSION,
                APPLICATION_REGION,
                config
            );
        } catch (error) {
            // Ignore errors thrown during CloudWatch RUM web client initialization
        }
    }
};

const awsRumUtils = {
    initRum,
    recordCustomEvent,
};

export default awsRumUtils;
